import {UnfoundProjectsTable} from "./UnfoundProjectsTable";
import {getPaginationConfig} from "../../util/showAllPagination";


const ProjectSearchUnfoundProjectsTab = ({
                                          loading,
                                          unfoundProjects
                                        }) => {
  return (<>
    <UnfoundProjectsTable
      unfoundProjects={unfoundProjects}
      pagination={getPaginationConfig(unfoundProjects.length)}
      loading={loading}
      permissions={null}
      user={null}
      handleUnfoundProjectResponse={null}
    />
  </>);
};

export {ProjectSearchUnfoundProjectsTab};